/**
 * 工程のチェック項目
 */
export default class Subtask {
  public constructor(
    public id: number,
    public name: string,
    public done: boolean,
    public dueDate: string
  ) {}

  toFormData(): FormData {
    const d = new FormData();
    d.append("id", String(this.id));
    d.append("name", this.name);
    d.append("done", String(this.done));
    d.append("dueDate", this.dueDate);
    return d;
  }
}
